var overlayModule = angular.module('overlay', []);

overlayModule.service('overlay', [function () {
    var added_classes = null;
    var overlay_visible = false;
    var overlay_element = null;

    function update_body_class(update) {
        if (added_classes) {
            angular.element(document.body).removeClass(added_classes);
        }
        if (update) {
            angular.element(document.body).addClass(update);
        }
        added_classes = update;
    }

    var overlay_called_id = 0;

    return {
        /**
         * @param [add_classes] - add the classes to document.body
         * @returns {number}
         */
        show: function (add_classes) {
            update_body_class(add_classes);

            if (!overlay_visible) {
                var heightHeader = $('header[role="banner"]').outerHeight();
                var heightMain = $('main').outerHeight();
                var heightFooter = $('footer[role="contentinfo"]').outerHeight();
                var heightBody = heightHeader + heightMain + heightFooter;

                var style = 'style="height: ' + heightBody + 'px"';
                if (!overlay_element) {
                    $('#site').prepend('<md-backdrop id="md-backdrop" class="md-sidenav-backdrop md-opaque ng-scope md-default-theme" ' + style + '></md-backdrop>');
                    overlay_element=true;
                }else{
                    document.getElementById('md-backdrop').style.height = heightBody + 'px';
                }
                overlay_visible = true;
            }
            document.getElementById('md-backdrop').style.display = 'block';
            return ++overlay_called_id;
        },
        /** @param [called_id] - hide the overlay only if the called_id is the latest */
        hide: function (called_id) {
            if (called_id && called_id != overlay_called_id) {
                return;
            }

            update_body_class();
            if (overlay_visible) {
                setTimeout(function () {
                    if (overlay_visible === false) {
                        document.getElementById('md-backdrop').style.display = 'none';
                    }
                }, 150);
                overlay_visible = false;
            }
        }
    };
}]);